export default "__VITE_ASSET__BcMZgIUV__"